export default __webpack_public_path__ + "static/media/4.fb54e22a.webp";